import { Pipe, PipeTransform } from '@angular/core';
import { canPaymentBeResent } from '../helpers/can-payment-be-resent';
import { Payment } from '../models/Payment';

@Pipe({name: 'canPaymentBeResent'})
export class CanPaymentBeResentPipe implements PipeTransform {
  transform(payment: Payment): boolean {
    return canPaymentBeResent(payment);
  }
}
